import { ChartOption, ReportResult } from "../entities/reportEntity";
import { isEmpty } from "@/utils/Common";

export default function (definition: any, chartOption: ChartOption, datas: ReportResult) {
  const dataValues: Array<Array<Array<number>>> = [];

  const xaxisLabels: Array<string> = [];
  const yaxisLabels: Array<string> = [];
  for (let i = 0; i < datas.rowCount; i++) {
    if (datas.rowDimNodes[i][0] && !datas.rowDimNodes[i][0].total && xaxisLabels.indexOf(datas.rowDimNodes[i][0].label) < 0) {
      xaxisLabels.push(datas.rowDimNodes[i][0].label);
    }
    if (datas.rowDimNodes[i][1] && !datas.rowDimNodes[i][1].total && yaxisLabels.indexOf(datas.rowDimNodes[i][1].label) < 0) {
      yaxisLabels.push(datas.rowDimNodes[i][1].label);
    }

    if (datas.rowDimNodes[i][0] && !datas.rowDimNodes[i][0].total && datas.rowDimNodes[i][1] && !datas.rowDimNodes[i][1].total) {
      for (let k = 0; k < datas.colCount; k++) {
        if (datas.colDimNodes[k][0].total) {
          continue;
        }
        let count = 0;
        if (datas.dataValues[datas.rowColIndexes[i][k]]) {
          count = datas.dataValues[datas.rowColIndexes[i][k]][0];
        }
        if (!dataValues[k]) {
          dataValues[k] = [];
        }
        if (!dataValues[k][xaxisLabels.length - 1]) {
          dataValues[k][xaxisLabels.length - 1] = [];
        }
        dataValues[k][xaxisLabels.length - 1][yaxisLabels.length - 1] = count;
      }
    }
  }

  xaxisLabels.unshift("");
  yaxisLabels.unshift("");

  xaxisLabels.push("");
  yaxisLabels.push("");

  const data: Array<Array<Array<number>>> = [];
  const legendList: Array<string> = [];
  for (let i = 0; i < datas.colCount; i++) {
    if (datas.colDimNodes[i][0].total) {
      continue;
    }
    legendList.push(datas.colDimNodes[i][0].label);
    data.push([]);
  }

  for (let i = 0; i < xaxisLabels.length; i++) {
    for (let j = 0; j < yaxisLabels.length; j++) {
      if (i == 0 || i == xaxisLabels.length - 1) {
        for (let k = 0; k < legendList.length; k++) {
          data[k].push([i, j, 0]);
        }
      } else if (j == 0 || j == yaxisLabels.length - 1) {
        for (let k = 0; k < legendList.length; k++) {
          data[k].push([i, j, 0]);
        }
      } else {
        for (let k = 0; k < legendList.length; k++) {
          data[k].push([i, j, dataValues[k][i - 1][j - 1]]);
        }
      }
    }
  }

  const scatterSeries = [];
  for (let i = 0; i < legendList.length; i++) {
    scatterSeries.push({
      name: "scatter-" + legendList[i],
      type: "scatter",
      legendHoverLink: false,
      symbol: i > 0 ? "none" : "",
      symbolSize: 0.01,
      data: data[i]
    });
  }

  const option: any = {
    legend: {
      type: "scroll",
      left: 100,
      right: 100,
      y: "12%",
      data: legendList
    },
    tooltip: {
      position: "right",
      trigger: "item",
      // formatter: "{a} <br/>{b}: {c} ({d}%)",
      formatter: function (params: any) {
        return params.seriesName.replace(/PATBIS/g, "<br/>") + "<br/>" + params.name + ": " + params.value + " (" + params.percent + "%)";
      }
    },
    grid: {
      top: "24%",
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true
    },
    xAxis: {
      type: "category",
      data: xaxisLabels,
      position: "top",
      boundaryGap: false,
      splitLine: {
        show: true,
        interval: function (index: number, value: any) {
          return index > 0 && index < xaxisLabels.length - 1;
        },
        lineStyle: {
          color: "#999",
          type: "solid"
        }
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        rotate: -30
      },
      axisTick: {
        show: false
      }
    },
    yAxis: {
      type: "category",
      data: yaxisLabels,
      boundaryGap: false,
      splitLine: {
        show: true,
        interval: function (index: number, value: any) {
          return index > 0 && index < yaxisLabels.length - 1;
        },
        lineStyle: {
          color: "#999",
          type: "solid"
        }
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    series: scatterSeries
  };

  if (!chartOption.hideTitle && !isEmpty(chartOption.title)) {
    option.title = {
      left: "center",
      text: chartOption.title
    };
    if (!isEmpty(chartOption.subTitle)) {
      option.title.subtext = chartOption.subTitle;
    }
  }

  if (!chartOption.hideToolbox) {
    option.toolbox = {
      show: true,
      feature: {
        saveAsImage: {}
      }
    };
  }

  const refreshChart = function (chart: any, params: any) {
    console.info("refresh chart...");
    const selected = chart.getOption().legend[0].selected;
    const series = chart.getOption().series.slice(0, 3);
    let maxData = 0;
    for (var i = 1; i < xaxisLabels.length - 1; i++) {
      for (var j = 1; j < yaxisLabels.length - 1; j++) {
        var idx = i * yaxisLabels.length + j;
        var v = 0;
        for (var k = 0; k < chart.getOption().legend[0].data.length; k++) {
          if (!chart.getOption().legend[0].selected.hasOwnProperty(chart.getOption().legend[0].data[k]) ||
            chart.getOption().legend[0].selected[chart.getOption().legend[0].data[k]]) {
            v += data[k][idx][2];
          }
        }

        if (v > maxData) {
          maxData = v;
        }
      }
    }

    for (var i = 1; i < xaxisLabels.length - 1; i++) {
      for (var j = 1; j < yaxisLabels.length - 1; j++) {
        var idx = i * yaxisLabels.length + j;

        let sum = 0;
        const pieData = [];
        for (var k = 0; k < chart.getOption().legend[0].data.length; k++) {
          var v = 0;
          if (!chart.getOption().legend[0].selected.hasOwnProperty(chart.getOption().legend[0].data[k]) ||
            chart.getOption().legend[0].selected[chart.getOption().legend[0].data[k]]) {
            sum += data[k][idx][2];
            v = data[k][idx][2];
          }

          pieData.push({ name: chart.getOption().legend[0].data[k], value: v });
        }

        const radius = sum / maxData * 32;

        series.push({
          type: "pie",
          name: definition.rowDims[0].label + ": " + xaxisLabels[i] +
            "PATBIS" + definition.rowDims[1].label + ": " + yaxisLabels[j] +
            "PATBIS" + definition.measures[0].label + ": " + sum,
          itemStyle: {
            normal: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              }
            }
          },
          radius: radius,
          center: chart.convertToPixel({ seriesIndex: 0 }, [i, j]),
          data: pieData
        });
      }
    }

    option.animation = true;
    option.series = series;

    option.legend = {
      type: "scroll",
      // left: 100,
      // right: 100,
      y: "12%",
      data: legendList,
      selected: selected
    };

    chart.setOption(option, true);
  };

  option.events = [{
    name: "finished",
    handler: function (chart: any, params: any) {
      chart.off("finished");
      refreshChart(chart, params);
    }
  }, {
    name: "resized",
    handler: function (chart: any, params: any) {
      refreshChart(chart, params);
    }
  }];

  return option;
}
